import http from "./http_common";
import _ from "lodash";

class DrugServices {
  constructor() {
    this.debouncedDrugList = _.debounce(
      (medicineName, pageNo, pageSize, callback) => {
        this.fetchDrugList(medicineName, pageNo, pageSize).then(callback);
      },
      300
    );
  }

  DrugList({ medicineName = "", pageNo = 1, pageSize = 40 }) {
    return new Promise((resolve) => {
      this.debouncedDrugList(medicineName, pageNo, pageSize, resolve);
    });
  }

  fetchDrugList(medicineName = "", pageNo = 1, pageSize = 40) {
    const searchParam = medicineName ? `medicineName=${medicineName}&` : "";

    return http.get(
      `/drugInfo/listMdmDrug?${searchParam}pageNo=${pageNo}&pageSize=${pageSize}&pharmacyId=DZA5301051`
    );
  }
}

export default new DrugServices();
